/* eslint-disable @typescript-eslint/no-explicit-any */
import type { EntitlementsResponse } from '@/types/backend'

export function isReadonly(ent?: EntitlementsResponse) {
  if (!ent?.ok) return false
  const isActive =
    (ent as any).account?.isActive ?? (ent as any).isActive ?? true
  const suspendedAt =
    (ent as any).account?.suspendedAt ?? (ent as any).suspendedAt ?? null
  return !isActive || !!suspendedAt || !ent.canWrite
}
